export default {"src":"/_next/static/media/bt.1392c02b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};